import { render } from "./JobForm.vue?vue&type=template&id=48818e48"
import script from "./JobForm.vue?vue&type=script&lang=js"
export * from "./JobForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__